import featureOne from "../../assets/images/webp/programs/featureOne.webp";

import "./index.scss";

const WorkoutFeature = ({ featureImg, title, description }) => {
  return (
    <div className="single-feature">
      <img className="image" src={featureImg} alt="" />
      <div className="title">{title}</div>
      <div className="description">{description}</div>
    </div>
  );
};
export default WorkoutFeature;
